module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-jpg-d16c31dc73965d7411745f7446dfea9e.svg";